import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F8FAFC] via-[#ECFDF5] to-[#D1FAE5] px-6" data-testid="not-found-page">
      <Seo title="Page not found (404) | MoneyFeed" description="The page you were looking for could not be found." path="/404" noindex />
      <div className="text-center max-w-md">
        <p className="text-6xl font-bold text-[#064E3B] mb-3">404</p>
        <h1 className="text-2xl font-bold text-[#064E3B] mb-3">Page not found</h1>
        <p className="text-gray-600 mb-8">The page you were looking for doesn't exist or may have moved.</p>
        <div className="flex flex-wrap justify-center gap-4 text-sm font-semibold">
          <Link to="/" className="px-5 py-2.5 rounded-full bg-[#84CC16] text-black hover:bg-[#65A30D]" data-testid="not-found-home">Back to home</Link>
          <Link to="/whatsapp-bookkeeping" className="px-5 py-2.5 rounded-full border border-[#064E3B] text-[#064E3B] hover:bg-[#ECFDF5]">WhatsApp bookkeeping</Link>
          <Link to="/blog" className="px-5 py-2.5 rounded-full border border-[#064E3B] text-[#064E3B] hover:bg-[#ECFDF5]">Blog</Link>
        </div>
      </div>
    </div>
  );
}
